import React from 'react'
import useStyle from './style'
import CasesReadyForExport from './CasesReadyForExport'

export default useStyle(props => {
	const { classes } = props

	return (
		<div className={`${classes.container} ${classes.fontFamily}`}>
			<CasesReadyForExport />
		</div>
	)
})
